import { isLocal, tryLocalStorageGet } from './env';
export const LOCALSTORAGE_DEBUG_KEY = 'hs_video_debug';
export function hasDebugQueryParam() {
  return window.location.search.includes('debug=true');
}
export function isDebugEnabled() {
  if (isLocal() || window.hsVideoDebug) {
    return true;
  }
  return tryLocalStorageGet(LOCALSTORAGE_DEBUG_KEY) === 'true' || hasDebugQueryParam();
}
export function debugLog(...args) {
  if (isDebugEnabled()) {
    const first = args.shift();
    console.log.apply(console, [`[hs-video] ${first}`, ...args]);
  }
}